(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-customers"]) return;
  try {
    
  (function () {
    /* ülke seçilince il listesini doldur (Shopify all_country_option_tags data-provinces) */
    function fill(country) {
      var form = country.form;
      var prov = form && form.querySelector('[data-addr-province]');
      var wrap = form && form.querySelector('[data-addr-province-wrap]');
      if (!prov) return;
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }
      var want = prov.value || prov.getAttribute('data-default');
      prov.innerHTML = '';
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        if (p[0] === want || p[1] === want) o.selected = true;
        prov.appendChild(o);
      });
      if (wrap) wrap.hidden = list.length === 0;
    }
    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-addr-country]'), function (c) {
        if (c.__addr) return;
        c.__addr = true;
        var def = c.getAttribute('data-default');
        if (def) {
          for (var k = 0; k < c.options.length; k++) {
            if (c.options[k].value === def || c.options[k].textContent === def) { c.selectedIndex = k; break; }
          }
        }
        fill(c);
        c.addEventListener('change', function () { var p = c.form.querySelector('[data-addr-province]'); if (p) p.value = ''; fill(c); });
      });
    }
    document.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('[data-addr-delete]') && !window.confirm('Bu adresi silmek istediğine emin misin?')) e.preventDefault();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    /* "Şifremi unuttum" bağlantısı: :target desteklenmezse de çalışsın */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#recover"], a[href="#login"]');
      var rec = document.getElementById('recover');
      if (!a || !rec) return;
      rec.classList.toggle('is-shown', a.getAttribute('href') === '#recover');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.dedeMarquee) return;
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    /* CSS'teki telefon sorgusunun aynısı: hız tabanı yalnız şerit gerçekten telefon boyutundayken uygulanır */
    var phone = window.matchMedia ? window.matchMedia('(max-width:700px),(max-width:1000px) and (max-height:500px)') : { matches: false };
    var list = [];
    var each = function (nodes, fn) { Array.prototype.forEach.call(nodes, fn); };

    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var m = en.target.__mqs;
        if (m) { m.visible = en.isIntersecting; paint(m); }
      });
    }, { rootMargin: '80px 0px' }) : null;

    var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
      entries.forEach(function (en) {
        var r = en.target.closest('[data-mqs]');
        if (r && r.__mqs) schedule(r.__mqs);
      });
    }) : null;

    /* şerit ekrana yaklaşınca küçük görselleri hemen yükle: yatayda kırpılan lazy görseller aksi halde
       görünür alana girdikleri anda yüklenmeye başlar ve boş hap olarak kayar */
    function paint(m) {
      if (m.visible && !m.eager) {
        m.eager = true;
        each(m.root.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
      }
      m.root.classList.toggle('is-offscreen', !m.visible || document.hidden);
    }

    function schedule(m) {
      if (m.pending) return;
      m.pending = requestAnimationFrame(function () { m.pending = 0; build(m, false); });
    }

    function clear(m) {
      each(m.track.querySelectorAll('[data-mqs-clone]'), function (c) { c.parentNode.removeChild(c); });
      /* aynı CSS animasyonu yeniden kullanılabilir: kaydırma hızlandırmasını sıfırla ki takılı kalmasın */
      if (m.anim) { try { m.anim.playbackRate = 1; } catch (e) {} }
      m.copies = 0; m.anim = null; m.rate = 1; m.dur = 0;
      m.root.classList.remove('is-ready');
      m.lean.style.transform = '';
    }

    /* yarım iz en az görünür alan kadar olmalı: grup + kopyalar = yarım, ardından aynısı bir kez daha */
    function build(m, force) {
      if (mq.matches || !m.group.children.length) { clear(m); return; }
      var gw = m.group.offsetWidth, vw = m.vp.clientWidth;
      if (!gw || !vw) return;
      var need = Math.max(1, Math.ceil(vw / gw));
      /* bir tur = grubun tamamı geçer; grup ekrandan kısaysa bir ekran genişliği geçer (az yazıda sürünmesin) */
      var dur = Math.round(m.speed * need * gw / Math.max(gw, vw) * 100) / 100;
      /* telefonda yazılar küçüldüğü için aynı süre "duruyor" gibi görünür: en az ~45 px/sn ak */
      if (phone.matches) dur = Math.min(dur, Math.max(8, Math.round(need * gw / 0.45) / 100));
      if (!force && need === m.copies && Math.abs(dur - m.dur) < 0.2) return;
      var prog = progress(m);
      if (force || need !== m.copies) cloneGroups(m, need);
      m.dur = dur;
      m.root.style.setProperty('--mqs-dur', dur + 's');
      m.root.classList.add('is-ready');
      var anims = m.track.getAnimations ? m.track.getAnimations() : [];
      m.anim = anims.length ? anims[0] : null;
      /* süre/genişlik değişince şerit zıplamasın: aynı ilerleme oranından devam et */
      if (m.anim && prog > 0) {
        try { m.anim.currentTime = prog * m.anim.effect.getComputedTiming().duration; } catch (e) {}
      }
    }

    function progress(m) {
      if (!m.anim || !m.anim.effect) return 0;
      var d = m.anim.effect.getComputedTiming().duration, t = m.anim.currentTime;
      return d && t ? (t % d) / d : 0;
    }

    function cloneGroups(m, need) {
      clear(m);
      for (var i = 1; i < need * 2; i++) {
        var c = m.group.cloneNode(true);
        c.removeAttribute('data-mqs-group');
        c.setAttribute('data-mqs-clone', '');
        /* inert değil: kopyalardaki bağlantılar fareyle tıklanabilmeli; ekran okuyucu ve Tab için gizli */
        c.setAttribute('aria-hidden', 'true');
        each(c.querySelectorAll('a, button, [tabindex]'), function (el) { el.setAttribute('tabindex', '-1'); });
        each(c.querySelectorAll('[data-shopify-editor-block], [id]'), function (el) {
          el.removeAttribute('data-shopify-editor-block'); el.removeAttribute('id');
        });
        m.track.appendChild(c);
      }
      m.copies = need;
    }

    /* seçili / odaklanan öğeyi görünür alanın ortasına getir */
    function reveal(m, item) {
      if (!item) return;
      /* hareket azaltılmışsa animasyon yok, şerit elle kaydırılır: öğeyi kaydırma konumuyla ortala */
      if (!m.anim || !m.anim.effect) {
        if (mq.matches) m.vp.scrollLeft = Math.max(0, item.offsetLeft - (m.vp.clientWidth - item.offsetWidth) / 2);
        return;
      }
      m.vp.scrollLeft = 0;
      var half = m.track.offsetWidth / 2, d = m.anim.effect.getComputedTiming().duration;
      if (!half || !d) return;
      var x = Math.max(0, (m.vp.clientWidth - item.offsetWidth) / 2) - item.offsetLeft;
      var p = -Math.min(0, Math.max(1 - half, x)) / half;
      var t = m.root.classList.contains('mqs--dir-right') ? d * (1 - p) : d * p;
      m.anim.currentTime = Math.min(d - 1, Math.max(0, t));
    }

    function init(root) {
      if (root.__mqs) return;
      var vp = root.querySelector('[data-mqs-viewport]'), track = root.querySelector('[data-mqs-track]'),
          group = root.querySelector('[data-mqs-group]'), lean = root.querySelector('[data-mqs-lean]');
      if (!vp || !track || !group || !lean) return;
      var m = {
        root: root, vp: vp, track: track, group: group, lean: lean,
        btn: root.querySelector('[data-mqs-toggle]'),
        speed: parseFloat(root.getAttribute('data-speed')) || 28,
        fx: root.hasAttribute('data-mqs-fx'),
        visible: true, eager: false, copies: 0, dur: 0, anim: null, rate: 1, pending: 0, ptr: 0
      };
      root.__mqs = m;
      list.push(m);
      if (m.btn) m.btn.addEventListener('click', function () {
        var paused = root.classList.toggle('is-paused');
        m.btn.setAttribute('aria-label', paused ? 'Kayan yazıyı başlat' : 'Kayan yazıyı durdur');
      });
      /* yalnız klavye odağında öğeyi ortaya getir; fare/dokunma tıklamasında şerit zıplamasın */
      vp.addEventListener('pointerdown', function () { m.ptr = Date.now(); });
      vp.addEventListener('focusin', function (e) {
        if (Date.now() - m.ptr < 800) return;
        var item = e.target.closest && e.target.closest('.mqs__item');
        if (item && !item.closest('[data-mqs-clone]')) reveal(m, item);
      });
      if (io) io.observe(root);
      if (ro) { ro.observe(group); ro.observe(vp); }
      build(m, true);
    }

    function destroy(root) {
      var m = root.__mqs;
      if (!m) return;
      if (m.pending) cancelAnimationFrame(m.pending);
      if (io) io.unobserve(root);
      if (ro) { ro.unobserve(m.group); ro.unobserve(m.vp); }
      var i = list.indexOf(m);
      if (i > -1) list.splice(i, 1);
      root.__mqs = null;
    }

    function initAll(scope) { each((scope || document).querySelectorAll('[data-mqs]'), init); }

    /* kaydırırken hızlanma + hafif eğilme (rAF ile tek döngü, durunca kendini kapatır) */
    var fx = { y: window.pageYOffset, t: 0, skew: 0, rate: 1, raf: 0 };
    function tick(now) {
      fx.raf = 0;
      var y = window.pageYOffset, v = (y - fx.y) / (fx.t < 0 ? 16 : Math.max(8, now - fx.t));
      fx.y = y; fx.t = now;
      fx.skew += (Math.max(-6, Math.min(6, -v * 2.2)) - fx.skew) * 0.14;
      fx.rate += (1 + Math.min(2.2, Math.abs(v) * 0.9) - fx.rate) * 0.14;
      var idle = v === 0 && Math.abs(fx.skew) < 0.02 && fx.rate - 1 < 0.01;
      if (idle) { fx.skew = 0; fx.rate = 1; }
      list.forEach(function (m) {
        if (!m.fx || !m.anim) return;
        var off = mq.matches || m.root.classList.contains('is-paused');
        var sk = off ? 0 : fx.skew, rt = off ? 1 : fx.rate;
        if (m.visible || !sk) m.lean.style.transform = sk ? 'skewX(' + sk.toFixed(2) + 'deg)' : '';
        if (Math.abs(rt - m.rate) > 0.03 || (rt === 1 && m.rate !== 1)) { m.rate = rt; m.anim.playbackRate = rt; }
      });
      if (idle) fx.t = 0; else fx.raf = requestAnimationFrame(tick);
    }
    window.addEventListener('scroll', function () {
      if (fx.raf || mq.matches) return;
      if (!list.some(function (m) { return m.fx && m.anim; })) { fx.y = window.pageYOffset; return; }
      if (!fx.t) fx.t = -1;
      fx.raf = requestAnimationFrame(tick);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () { list.forEach(paint); });
    var onPref = function () { list.forEach(function (m) { build(m, true); }); };
    if (mq.addEventListener) mq.addEventListener('change', onPref); else if (mq.addListener) mq.addListener(onPref);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { list.forEach(function (m) { build(m, false); }); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { each(e.target.querySelectorAll('[data-mqs]'), destroy); });
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target.closest && e.target.closest('.mqs__item'), root = item && item.closest('[data-mqs]');
      if (!root || !root.__mqs) return;
      root.classList.add('is-selecting');
      reveal(root.__mqs, item);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest && e.target.closest('[data-mqs]');
      if (root) root.classList.remove('is-selecting');
    });

    window.dedeMarquee = { init: initAll };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scroll-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MQ = '(prefers-reduced-motion: no-preference) and (min-height: 460px)';
    var DESK = '(min-width: 901px), (orientation: landscape)';
    var TOUCH = '(hover: none) and (pointer: coarse)';
    var SWIPE = '(max-width: 900px)'; /* burada açılar yatay kaydırma şeridinde: kaydırmaya bağlı geçiş kapanır */
    var DWELL = 0.34; /* dilimin ortasında ürünün sabit kaldığı pay */
    var FW = 0.24; /* açı görselleri arası geçiş penceresi (dar = daha az çift görüntü) */
    /* dokunmatik: açı değişimleri dilimin ortasına, ürünün neredeyse hiç kıpırdamadığı yere toplanır.
       MW = açıların yayıldığı yarım pencere (3 görselde değişimler ±MW/2'de; aralarında MW kadar kaydırma kalır,
            böylece parmakla hızlı kaydırmada bile her açı ekranda görülecek kadar durur),
       MO = pencerenin ileri kayması (ürün sahneden çıkarken girdiğinden daha geç solar; üç açı eşit pay alsın),
       XF = görsel değişiminin kaydırma genişliği (kısa = net geçiş, çözülme değil),
       XS = ezilme/eğilme zarfı: değişimden geniştir ki hızlı kaydırmada da dönüş hareketi görülsün.
       Ezilme/eğilme yalnızca hareket sırasındadır: kaydırmada yumuşatılmış konumun hedefin gerisinde kalışı ölçülür
       (MV'de tam etki); sayfa durunca ürün birkaç kare içinde dik ve tam boyuna döner, değişimin yanında dursa bile.
       M1 = iki görselli üründe tek değişimin dilim ortasına uzaklığı: noktaların indiği dinlenme noktasında (v=i)
            ürün değişimin eşiğinde kalmaz, net biçimde ilk açıyı gösterir. */
    var MW = 0.34, MO = 0.03, XF = 0.055, XS = 0.2, MV = 0.005, M1 = 0.1;
    var PXS = 0.4; /* bir açı için gereken yatay sürükleme (ürün genişliğinin oranı) */
    var HK = 'dede-p3d-spin'; /* ipucu bir kez çevirdikten sonra ziyaret boyunca gösterilmez */
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function ease(t) { return t * t * (3 - 2 * t); }
    function mqOn(m, fn) { if (m.addEventListener) m.addEventListener('change', fn); else if (m.addListener) m.addListener(fn); }
    function mqOff(m, fn) { if (m.removeEventListener) m.removeEventListener('change', fn); else if (m.removeListener) m.removeListener(fn); }

    /* yapışkan/sabit başlık varsa sahne onun altında sabitlenir (şeffaf, banner üstündeki başlık kayar → 0).
       Temanın başlığı aşağı kaydırınca gizleniyorsa (:root'a --header-offset yazar) sahne en üste sabitlenir;
       yoksa başlık gizlendiğinde sahnenin üstünde boş bir şerit kalırdı. Başlık geri gelince sahnenin üstüne biner,
       noktalar --header-offset kadar aşağı kayar. */
    function headerOffset(prev) {
      var h = document.querySelector('.site-header');
      if (!h) return 0;
      if (h.classList.contains('is-open')) return prev;
      if (document.documentElement.style.getPropertyValue('--header-offset')) return 0;
      for (var el = h, k = 0; el && k < 2; el = el.parentElement, k++) {
        var pos = getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') return Math.round(el.getBoundingClientRect().height);
      }
      return 0;
    }

    function init(root) {
      if (!root || root.__p3d || !('IntersectionObserver' in window)) return;
      var track = root.querySelector('[data-p3d-track]');
      var stage = root.querySelector('[data-p3d-stage]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-p3d-item]'));
      if (!track || !stage || !items.length) return;
      root.classList.add('p3d--js');

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-p3d-dot]'));
      var mq = window.matchMedia(MQ), desk = window.matchMedia(DESK);
      var touch = window.matchMedia(TOUCH), redu = window.matchMedia('(prefers-reduced-motion: reduce)');
      var swipe = window.matchMedia(SWIPE);
      var spinOn = root.hasAttribute('data-spin');
      var n = items.length, R = parseFloat(root.getAttribute('data-rot')) || 0;
      var P = items.map(function (el, i) {
        var fr = Array.prototype.slice.call(el.querySelectorAll('[data-p3d-frame]'));
        /* spin: parmakla çevirmeden gelen açı kayması, base: kaydırmadan gelen açı konumu */
        return { el: el, fr: fr, fv: fr.map(function () { return {}; }), v: {}, idle: i > 0, far: el.classList.contains('is-far'), spin: 0, base: 0, fig: el.querySelector('.p3d__fig') };
      });
      var boxes = root.querySelectorAll('.p3d__box');
      var H = 1, W = 1, B = 1, top = 0, live = false, raf = 0, x = null, last = null, t0 = 0, cur = 0, dir = 1;
      /* mv: kaydırma hareketi (yumuşatılmış konumun geride kalışı), zm: sayfa yakınlaştırılmış mı,
         gi/gt: noktayla (ya da klavyeyle) gidilen ürün ve zamanı */
      var pts = 0, dg = null, sp = { i: 0, to: 0, on: false }, mv = 0, zm = false, gi = -1, gt = 0;

      function set(cache, el, k, val) {
        if (cache[k] !== val) { cache[k] = val; el.style.setProperty(k, val); }
      }
      /* metin alanına sığmayan ürünlere kademeli data-fit (1: etiketler gizli, 2: metin 2 satır, 3: başlık+metin 1 satır).
         Yalnızca açılışta, yazı tipi yüklenince ve boyut değişince çalışır; kaydırma sırasında ölçüm yapılmaz. */
      function fit() {
        if (!mq.matches) return;
        items.forEach(function (el) { el.removeAttribute('data-fit'); });
        var el0 = items[0], cs = getComputedStyle(el0), c0 = el0.querySelector('.p3d__copy');
        var avail = desk.matches
          ? el0.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom)
          : (c0 ? c0.clientHeight : 0);
        if (avail < 40) return;
        var todo = items;
        for (var lv = 1; lv <= 3 && todo.length; lv++) {
          todo = todo.filter(function (el) {
            var k = el.querySelector('.p3d__copy'), a = null, b = 0;
            k = k ? k.children : [];
            for (var q = 0; q < k.length; q++) {
              if (!k[q].offsetHeight) continue;
              if (a === null) a = k[q].offsetTop;
              b = k[q].offsetTop + k[q].offsetHeight;
            }
            return a !== null && b - a > avail + 1;
          });
          for (var m = 0; m < todo.length; m++) todo[m].setAttribute('data-fit', lv);
        }
      }
      function measure() {
        var t = headerOffset(top);
        if (t !== top) { top = t; root.style.setProperty('--p3d-top', t + 'px'); }
        var h = stage.offsetHeight || window.innerHeight, w = stage.offsetWidth || window.innerWidth;
        var changed = h !== H || w !== W;
        H = h; W = w; B = 1;
        if (changed) fit();
        for (var q = 0; q < boxes.length && B < 2; q++) B = boxes[q].offsetWidth || 1;
        return changed;
      }
      /* x: sürekli konum. -1.5…-0.5 sahne girerken, -0.5…n-0.5 sahne sabitken (ürün i, x=i'de ortada) */
      function target() {
        var r = track.getBoundingClientRect(), y = r.top - top, D = Math.max(1, r.height - H);
        if (y > 0) return -0.5 - clamp(y / (H * 0.6), 0, 1);
        return clamp(-y / D, 0, 1) * n - 0.5;
      }
      function uOf(v) {
        if (v < -0.5) return v + 0.5;
        if (v <= 0) return 0;
        if (v >= n - 1) return n - 1;
        var i = Math.floor(v);
        return i + ease(clamp((v - i - DWELL / 2) / (1 - DWELL), 0, 1));
      }

      function render(v) {
        var dk = desk.matches, tc = touch.matches, u = uOf(v), wk = W * (dk ? 0.3 : 0.46);
        /* mobilde metin ürünün altında: giren/çıkan ürünler üst üste binmesin diye yol ürün boyuna göre */
        var tin = dk ? H * 0.5 : Math.max(H * 0.36, B * 0.9), tout = dk ? H * 0.42 : Math.max(H * 0.3, B * 0.8);
        var c = u < -0.62 ? -1 : clamp(Math.round(u), 0, n - 1);
        for (var i = 0; i < n; i++) {
          var p = P[i], el = p.el, o = p.v, d = u - i, a = d < 0 ? -d : d;
          var far = a > 2.2;
          if (far !== p.far) {
            p.far = far; el.classList.toggle('is-far', far);
            /* gizlenirken (display:none) şeridin kaydırması sıfırlanır: noktalar da ilk açıya dönsün */
            if (far && p.ang) { p.ang.sc.scrollLeft = 0; mark(p.ang, 0); }
          }
          if (a >= 1) { /* sahne dışında: görünmez, will-change yok */
            if (!p.idle) {
              p.idle = true; el.classList.add('is-idle');
              set(o, el, '--op', '0'); set(o, el, '--wo', '0'); set(o, el, '--so', '0'); set(o, el, '--bo', '0');
            }
            continue;
          }
          if (p.idle) { p.idle = false; el.classList.remove('is-idle'); }
          var ty, rot, sc, op, ss, so, bo;
          if (d < 0) { /* giriyor: aşağıdan, dönük ve küçük */
            ty = a * tin; rot = -R * a; sc = 1 - 0.22 * a; op = clamp((0.66 - a) / 0.44, 0, 1);
            ss = sc; so = clamp((0.4 - a) / 0.4, 0, 1); bo = i === 0 ? 1 : clamp((1 - a) * 1.5, 0, 1);
          } else { /* çıkıyor: yukarı, ters yöne dönerek */
            ty = -a * tout; rot = R * 0.6 * a; sc = 1 - 0.1 * a; op = clamp((0.8 - a) / 0.5, 0, 1);
            ss = sc * (1 - 0.5 * a); so = clamp((0.3 - a) / 0.3, 0, 1); bo = 1;
          }
          var sq = 1, k = p.fr.length - 1;
          /* ≤900px: açılar şeritte, kaydırma açıyı değiştirmez (ezilme/eğilme de olmaz) */
          if (k > 0 && !swipe.matches) { /* açı görselleri: alttaki kare opak kalır, üstteki belirir */
            var lo, hi, q, tw;
            if (tc) {
              /* dokunmatik: her açı dilimin kendine ait net bir aralığında durur, aralar kısa geçiştir.
                 Kaydırmadan gelen konum ile parmakla çevirme toplanır; toplam baştan sona döner (son açı → ilk açı). */
              var nk = k + 1, bs = k * clamp((v - i + MW - (k > 1 ? MO : M1)) / (MW + MW), 0, 1);
              p.base = bs;
              var xp = (bs + p.spin) % nk;
              if (xp < 0) { xp += nk; }
              lo = Math.floor(xp);
              if (lo > k) { lo = k; }
              var dv = (xp - lo - 0.5) * (MW + MW) / k; /* değişim noktasına kaydırma cinsinden uzaklık */
              q = clamp(dv / XF + 0.5, 0, 1);
              hi = lo + 1;
              if (hi > k) { hi = lo; lo = 0; q = 1 - q; } /* sarmalama: alttaki ilk kare açılır, üstteki son kare solar */
              /* dönüş hissi hareketle gelir: parmakla çevrilen/oturan üründe tam, kaydırmada hıza göre, durunca 0 */
              var am = (dg && dg.lock && dg.i === i) || (sp.on && sp.i === i) ? 1 : clamp(mv / MV, 0, 1);
              tw = am * Math.cos(Math.PI * clamp(dv / XS, -0.5, 0.5));
            } else { /* fare/masaüstü: dilim ilerlemesi → kare (davranış değişmedi) */
              var ft = clamp((v - i + 0.36) / 0.72, 0, 1) * k;
              lo = Math.min(k - 1, Math.floor(ft));
              hi = lo + 1;
              q = clamp((ft - lo - 0.5 + FW / 2) / FW, 0, 1);
              tw = Math.sin(Math.PI * q);
            }
            for (var j = 0; j <= k; j++) {
              var f = j === lo ? 1 - ease(clamp((q - 0.4) / 0.6, 0, 1)) : j === hi ? ease(clamp(q / 0.7, 0, 1)) : 0;
              set(p.fv[j], p.fr[j], '--f', f.toFixed(3));
            }
            /* geçişte hafif ezilme (+ dokunmatikte eğilme): açı değişimi çözülme değil, dönme gibi okunsun */
            sq = 1 - (tc ? 0.13 : 0.06) * tw;
            if (tc) { rot -= 3.2 * tw; }
          }
          set(o, el, '--ty', ty.toFixed(1));
          set(o, el, '--rot', rot.toFixed(2));
          set(o, el, '--sc', sc.toFixed(4));
          set(o, el, '--sq', sq.toFixed(4));
          set(o, el, '--op', op.toFixed(3));
          set(o, el, '--ss', ss.toFixed(3));
          set(o, el, '--so', so.toFixed(3));
          set(o, el, '--bo', bo.toFixed(3));
          set(o, el, '--wx', (-d * wk).toFixed(1));
          set(o, el, '--wo', clamp(1 - a * 1.7, 0, 1).toFixed(3));
        }
        if (c !== cur) {
          cur = c;
          for (var m = 0; m < n; m++) P[m].el.classList.toggle('is-current', m === c);
          var ac = Math.max(0, c);
          dots.forEach(function (b, q) {
            b.classList.toggle('is-active', q === ac);
            if (q === ac) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          });
        }
      }

      /* parmak bırakıldıktan sonra açı hedefe yumuşakça oturur */
      function settle(dt) {
        if (!sp.on) return false;
        var p = P[sp.i], d = sp.to - p.spin;
        if (d < 0.0015 && d > -0.0015) { p.spin = sp.to; sp.on = false; return false; }
        p.spin += d * (1 - Math.pow(0.84, dt / 16.7));
        return true;
      }
      function tick(ts) {
        raf = 0;
        if (!mq.matches || document.hidden) return;
        var sdt = pts ? Math.min(64, ts - pts) : 16.7;
        pts = ts;
        var t = target();
        if (x === null) x = t;
        else {
          var dt = t0 ? Math.min(64, ts - t0) : 16.7;
          x += (t - x) * (1 - Math.pow(0.74, dt / 16.7));
        }
        if (last !== null && Math.abs(t - last) > 1e-4) {
          var nd = t > last ? 1 : -1;
          if (nd !== dir) { dir = nd; root.style.setProperty('--p3d-dir', dir); }
        }
        last = t;
        if (Math.abs(t - x) < 5e-4) { x = t; t0 = 0; } else { t0 = ts; request(); }
        mv = t > x ? t - x : x - t;
        if (settle(sdt)) request();
        if (!raf) pts = 0;
        render(x);
      }
      function request() { if (!raf) raf = requestAnimationFrame(tick); }
      function onScroll() { if (live) request(); }
      /* genişlik değişince (ekran döndü, pencere boyutlandı) şerit bulunduğu açıya yeniden oturur.
         Yalnızca genişlik değişiminde: iOS adres çubuğu açılıp kapanırken de resize gelir, süren kaydırma bozulmasın. */
      function onResize() {
        if (window.innerWidth !== WW) { WW = window.innerWidth; reseat(); }
        if (mq.matches && measure()) { x = null; request(); }
      }
      function onMq() { if (mq.matches) { measure(); fit(); x = null; cur = -2; request(); } }
      function onVis() { if (!document.hidden && live) { x = null; request(); } }

      /* bir ürünün diliminin ortasına kaydır */
      function go(i, instant) {
        if (!mq.matches) return;
        measure();
        var r = track.getBoundingClientRect(), D = Math.max(1, r.height - H);
        var y = (window.pageYOffset || document.documentElement.scrollTop) + r.top - top + ((i + 0.5) / n) * D;
        gi = i; gt = Date.now();
        window.scrollTo({ top: Math.round(y), behavior: instant ? 'auto' : 'smooth' });
      }

      dots.forEach(function (b, i) {
        b.addEventListener('click', function () { go(i); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, j = -1;
          if (k === 'ArrowDown' || k === 'ArrowRight') j = Math.min(n - 1, i + 1);
          else if (k === 'ArrowUp' || k === 'ArrowLeft') j = Math.max(0, i - 1);
          else if (k === 'Home') j = 0;
          else if (k === 'End') j = n - 1;
          if (j < 0) return;
          e.preventDefault();
          dots[j].focus();
          go(j);
        });
      });
      /* klavyeyle gizli bir ürünün bağlantısına gelinirse o ürüne kaydır */
      function onFocus(e) {
        if (!mq.matches) return;
        var it = e.target && e.target.closest ? e.target.closest('[data-p3d-item]') : null;
        var i = items.indexOf(it);
        if (i > -1 && i !== cur) go(i);
      }
      root.addEventListener('focusin', onFocus);

      /* ---- telefon/dikey tablet: açı şeridi (yatay kaydırma + nokta göstergeleri) ----
         Şerit tarayıcının kendi kaydırmasıdır; burada yalnızca hangi açıda olduğumuzu okuyup noktalara yazıyoruz
         ve noktaya basıldığında şeridi o açıya götürüyoruz. */
      var AK = 'dede-p3d-swipe'; /* "Kaydır" ipucu ilk geçişten sonra bu ziyarette tekrar çıkmaz */
      var angs = [], WW = window.innerWidth, hintS = true;
      try { hintS = !window.sessionStorage.getItem(AK); } catch (e) { hintS = true; }
      if (!hintS) root.classList.add('is-swiped');
      function swiped() {
        if (!hintS) return;
        hintS = false;
        Array.prototype.forEach.call(document.querySelectorAll('[data-p3d]'), function (r) { r.classList.add('is-swiped'); });
        try { window.sessionStorage.setItem(AK, '1'); } catch (e) {}
      }
      function mark(a, i) {
        if (i === a.i) return;
        a.i = i;
        for (var q = 0; q < a.dots.length; q++) {
          a.dots[q].classList.toggle('is-active', q === i);
          if (q === i) a.dots[q].setAttribute('aria-current', 'true'); else a.dots[q].removeAttribute('aria-current');
        }
      }
      function syncA(a) {
        var w = a.sc.clientWidth;
        if (!w) return;
        if (a.sc.scrollLeft > 2) swiped();
        mark(a, clamp(Math.round(a.sc.scrollLeft / w), 0, a.dots.length - 1));
      }
      function goA(a, i) {
        var L = i * (a.sc.clientWidth || 1);
        swiped(); mark(a, i);
        if (redu.matches || !a.sc.scrollTo) a.sc.scrollLeft = L; /* hareket azaltıldıysa anında geç */
        else a.sc.scrollTo({ left: L, behavior: 'smooth' });
      }
      function reseat() {
        for (var q = 0; q < angs.length; q++) {
          var a = angs[q], w = a.sc.clientWidth;
          if (w) a.sc.scrollLeft = a.i * w;
        }
      }
      P.forEach(function (p) {
        if (p.fr.length < 2) return;
        var wrap = p.el.querySelector('[data-p3d-angles]');
        var a = { sc: p.fr[0].parentNode, i: 0, raf: 0, dots: wrap ? Array.prototype.slice.call(wrap.querySelectorAll('[data-p3d-adot]')) : [] };
        a.on = function () { if (!a.raf) a.raf = requestAnimationFrame(function () { a.raf = 0; syncA(a); }); };
        a.sc.addEventListener('scroll', a.on, { passive: true });
        a.dots.forEach(function (b, i) {
          b.addEventListener('click', function () { goA(a, i); });
          b.addEventListener('keydown', function (e) {
            var k = e.key, m = a.dots.length - 1, j = -1;
            if (k === 'ArrowRight' || k === 'ArrowDown') j = Math.min(m, i + 1);
            else if (k === 'ArrowLeft' || k === 'ArrowUp') j = Math.max(0, i - 1);
            else if (k === 'Home') j = 0;
            else if (k === 'End') j = m;
            if (j < 0) return;
            e.preventDefault();
            a.dots[j].focus();
            goA(a, j);
          });
        });
        p.ang = a;
        angs.push(a);
      });
      /* 900px eşiği geçildi: şerit kurulur ya da kalkar → ilk açıya dön, sahneyi yeniden çiz */
      function onSwipeMq() {
        for (var q = 0; q < angs.length; q++) { angs[q].sc.scrollLeft = 0; mark(angs[q], 0); }
        if (mq.matches) { x = null; cur = -2; request(); }
      }
      mqOn(swipe, onSwipeMq);

      /* ---- geniş dokunmatik ekran (≥901px): ürünü parmakla çevirme ---- */
      var hintOn = false;
      if (spinOn) {
        try { hintOn = !window.sessionStorage.getItem(HK); } catch (e) { hintOn = true; }
        if (hintOn) root.classList.add('is-hint'); /* görünürlüğü CSS dokunmatik sorgusuna bırakılır */
      }
      function spun() { /* ilk çevirmeden sonra ipucu ziyaret boyunca kalkar */
        if (!hintOn) return;
        hintOn = false;
        Array.prototype.forEach.call(document.querySelectorAll('[data-p3d].is-hint'), function (r) { r.classList.remove('is-hint'); });
        try { window.sessionStorage.setItem(HK, '1'); } catch (e) {}
      }
      function tOf(list, id) {
        for (var q = 0; q < list.length; q++) { if (list[q].identifier === id) return list[q]; }
        return null;
      }
      function step() { return Math.max(72, B * PXS); } /* bir açı için gereken sürükleme (px) */
      function onTS(e) {
        onTX(); /* ikinci parmak (ör. yakınlaştırma) süren çevirmeyi keser: ürün en yakın açıya oturur */
        if (!live || zm || !mq.matches || !touch.matches || swipe.matches || e.touches.length !== 1 || cur < 0) return;
        if (gi !== cur && Date.now() - gt < 1600) return; /* noktayla başka ürüne kayılırken giden ürün çevrilmez */
        var p = P[cur], g = e.target;
        /* yalnızca sahnedeki açı görselli ürünün alanı (noktalar, metin ve buton dokunulmaz; tek görselde çevirme yok) */
        if (!p || p.fr.length < 2 || !g || !g.closest || g.closest('.p3d__fig') !== p.fig) return;
        var a = e.touches[0];
        dg = { id: a.identifier, i: cur, x: a.clientX, y: a.clientY, s: p.spin, lock: 0, v: 0, px: a.clientX, ts: e.timeStamp || 0 };
      }
      function onTM(e) {
        if (!dg) return;
        var a = tOf(e.touches, dg.id);
        if (!a) { onTX(); return; }
        var dx = a.clientX - dg.x, dy = a.clientY - dg.y;
        if (!dg.lock) {
          if (Math.abs(dy) > 8 && Math.abs(dy) >= Math.abs(dx)) { dg = null; return; } /* dikey: sayfa kaysın */
          /* yatay ağırlıklı hareketi tarayıcı kaydırmaz (pan-y): hepsi çevirmedir. Tarayıcı hareketi çoktan
             üstlendiyse (sayfa kayıyor, olay iptal edilemez) çevirme başlamaz. */
          if (Math.abs(dx) < 14) return; /* yön henüz belirsiz */
          if (!e.cancelable) { dg = null; return; }
          dg.lock = 1; dg.x = a.clientX; dg.px = a.clientX; dg.ts = e.timeStamp || 0; dg.s = P[dg.i].spin;
          sp.on = false; spun(); dx = 0;
        }
        if (e.cancelable) e.preventDefault();
        var tn = e.timeStamp || 0, dt = tn - dg.ts;
        if (dt > 0) dg.v = dg.v * 0.55 + ((a.clientX - dg.px) / dt) * 0.45; /* px/ms */
        dg.px = a.clientX; dg.ts = tn;
        P[dg.i].spin = dg.s - dx / step();
        request();
      }
      function onTE(e) {
        if (!dg) return;
        if (e && e.changedTouches && !tOf(e.changedTouches, dg.id)) return;
        var g = dg; dg = null;
        if (!g.lock) return;
        var p = P[g.i];
        /* atalet: parmak hâlâ hareket ederken bırakıldıysa hız bir miktar taşınır, sonra en yakın açıya oturur.
           Parmak durup bekledikten sonra kalkarsa (son hareketten 80 ms'den uzun) ya da çevirme yarıda kesilirse
           (olay yok) eski hız taşınmaz: ürün parmağın bıraktığı açıda kalır. */
        var gv = e && e.timeStamp && e.timeStamp - g.ts < 80 && Math.abs(g.v) > 0.25 ? g.v : 0;
        var pr = clamp(-gv / step() * 170, -2, 2);
        sp.i = g.i; sp.to = Math.round(p.base + p.spin + pr) - p.base; sp.on = true;
        if (redu.matches) { p.spin = sp.to; sp.on = false; } /* hareket azaltıldıysa doğrudan otur */
        request();
      }
      function onTX() { if (dg && dg.lock) onTE(); dg = null; }
      /* sayfa iki parmakla yakınlaştırıldığında çevirme kapanır, yana kaydırma tarayıcıya kalır */
      var vv = window.visualViewport;
      function onVV() {
        var z = vv.scale > 1.01;
        if (z === zm) return;
        zm = z; root.classList.toggle('is-zoom', z);
        if (z) onTX();
      }
      if (spinOn) {
        stage.addEventListener('touchstart', onTS, { passive: true });
        stage.addEventListener('touchmove', onTM, { passive: false });
        stage.addEventListener('touchend', onTE, { passive: true });
        stage.addEventListener('touchcancel', onTX, { passive: true });
        if (vv) { vv.addEventListener('resize', onVV); onVV(); }
      }

      var io = new IntersectionObserver(function (en) {
        var on = en[en.length - 1].isIntersecting;
        if (on === live) return;
        live = on;
        root.classList.toggle('is-live', on);
        if (on) {
          measure(); x = null;
          window.addEventListener('scroll', onScroll, { passive: true });
          request();
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      }, { rootMargin: '30% 0px 30% 0px' });
      io.observe(track);
      window.addEventListener('resize', onResize);
      document.addEventListener('visibilitychange', onVis);
      mqOn(mq, onMq);
      measure();
      /* yazı tipi gelince satır yükseklikleri değişir */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (root.__p3d) fit(); });

      root.__p3d = {
        go: function (i) { if (!mq.matches) return false; go(i, true); return true; },
        index: function (el) { return items.indexOf(el); },
        destroy: function () {
          io.disconnect();
          if (raf) cancelAnimationFrame(raf);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onResize);
          document.removeEventListener('visibilitychange', onVis);
          root.removeEventListener('focusin', onFocus);
          stage.removeEventListener('touchstart', onTS);
          stage.removeEventListener('touchmove', onTM);
          stage.removeEventListener('touchend', onTE);
          stage.removeEventListener('touchcancel', onTX);
          if (vv) vv.removeEventListener('resize', onVV);
          for (var q = 0; q < angs.length; q++) {
            angs[q].sc.removeEventListener('scroll', angs[q].on);
            if (angs[q].raf) cancelAnimationFrame(angs[q].raf);
          }
          mqOff(swipe, onSwipeMq);
          mqOff(mq, onMq);
          root.classList.remove('is-live', 'is-zoom');
          root.__p3d = null;
        }
      };
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-p3d]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-p3d]'), function (r) { if (r.__p3d) r.__p3d.destroy(); });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var it = e.target && e.target.closest ? e.target.closest('[data-p3d-item]') : null;
      var root = it && it.closest('[data-p3d]');
      if (!root || !root.__p3d) return;
      var i = root.__p3d.index(it);
      /* düzenleyicinin kendi kaydırmasından sonra doğru dilime geç; sade listede kartı göster */
      setTimeout(function () {
        if (root.__p3d && !root.__p3d.go(i) && it.scrollIntoView) it.scrollIntoView({ block: 'center' });
      }, 80);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-quiz"] && !Shopify.designMode) return;
  try {
    
  /* Kokunu bul: sonuçtaki ürün kartından sayfadan ayrılmadan sepete ekle (snippets/scent-quiz-product.liquid).
     Sepet çekmecesi dede:cart:added ile açılır (assets/cart-drawer.js); çekmece yoksa ya da hata olursa kısa bir bildirim çıkar.
     JavaScript yoksa form normal gönderilir ve sepete gidilir. */
  (function () {
    if (window.DedeSQAdd || !window.fetch) return;
    window.DedeSQAdd = true;
    var D = document;
    function note(root, t, err) {
      var live = root.querySelector('[data-sq-live]'), el = root.querySelector('[data-sq-toast]');
      if (!err && D.querySelector('[data-cart-drawer]')) {
        live.textContent = '';
        setTimeout(function () { live.textContent = t; }, 80);
        return;
      }
      el.textContent = t;
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.hidden = true; }, 4500);
    }
    D.addEventListener('submit', function (e) {
      var f = e.target, root = f.closest && f.closest('[data-sq]');
      if (!root || !f.classList.contains('sq-prod__form')) return;
      e.preventDefault();
      if (f._busy) return;
      var b = f.querySelector('button'), base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      f._busy = true;
      b.classList.add('is-busy');
      b.setAttribute('aria-busy', 'true');
      fetch(base + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          b.classList.add('is-added');
          note(root, 'Sepete eklendi: ' + (j.product_title || j.title || ''));
          D.dispatchEvent(new CustomEvent('dede:cart:added', { detail: j }));
          setTimeout(function () { b.classList.remove('is-added'); }, 2400);
        }, function (j) {
          note(root, (j && j.description) || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.', true);
        })
        .then(function () {
          f._busy = false;
          b.classList.remove('is-busy');
          b.removeAttribute('aria-busy');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__stl) return;
      root.__stl = true;
      var chips = root.querySelectorAll('[data-stl-city]');
      var cards = root.querySelectorAll('[data-stl-card]');
      var live = root.querySelector('[data-stl-live]');
      Array.prototype.forEach.call(chips, function (chip) {
        chip.addEventListener('click', function () {
          var city = chip.getAttribute('data-stl-city'), n = 0;
          Array.prototype.forEach.call(chips, function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          Array.prototype.forEach.call(cards, function (card) {
            var show = !city || card.getAttribute('data-city') === city;
            card.hidden = !show;
            if (show) n++;
          });
          if (live) live.textContent = n + ' satış noktası gösteriliyor';
        });
      });
    }
    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-stl]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    /* editörde gizli bir kart seçilirse filtreyi "Tümü"ne al */
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest && e.target.closest('[data-stl-card]');
      var root = card && card.closest('[data-stl]');
      if (card && card.hidden && root) {
        var all = root.querySelector('[data-stl-city=""]');
        if (all) all.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function toArr(list) { return Array.prototype.slice.call(list); }

  /* Kopyalar ekran okuyucudan gizlenir ve Tab sırasına girmez; fareyle tıklanabilir kalır (inert değil). */
  function cloneItem(node) {
    var c = node.cloneNode(true);
    c.classList.add('is-clone');
    c.setAttribute('aria-hidden', 'true');
    c.removeAttribute('data-shopify-editor-block');
    c.removeAttribute('id');
    toArr(c.querySelectorAll('[id],[data-shopify-editor-block]')).forEach(function (el) {
      el.removeAttribute('id');
      el.removeAttribute('data-shopify-editor-block');
    });
    toArr(c.querySelectorAll('a,button,input,select,textarea,[tabindex]')).forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    return c;
  }

  function isKeyboard(el) {
    try { return el.matches(':focus-visible'); } catch (e) { return true; }
  }

  function translateX(el) {
    var t = getComputedStyle(el).transform;
    var m = t && t !== 'none' ? t.match(/matrix(3d)?\(([^)]+)\)/) : null;
    if (!m) return 0;
    var v = m[2].split(',');
    return parseFloat(m[1] ? v[12] : v[4]) || 0;
  }

  function padLeft(el) { return parseFloat(getComputedStyle(el).paddingLeft) || 0; }

  function init(root) {
    if (!root) return;
    if (root.__voicesDestroy) root.__voicesDestroy();

    var rowsWrap = root.querySelector('[data-voices-rows]');
    var toggle = root.querySelector('[data-voices-toggle]');
    var toggleText = root.querySelector('[data-voices-toggle-text]');
    var video = root.querySelector('[data-voices-video]');
    var gif = root.querySelector('[data-voices-gif]');
    var speed = parseFloat(root.getAttribute('data-speed')) || 9;
    var wantRows = root.getAttribute('data-rows') === '1' ? 1 : 2;
    var reduce = !!(mq && mq.matches);
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var st = { user: false, visible: !('IntersectionObserver' in window), focusHold: false, editHold: false, touchHold: false, modalHold: false, moving: false, w: 0 };
    var offs = [], timers = {}, io = null, still = null, stillWait = false;

    function on(t, ev, fn, opt) { t.addEventListener(ev, fn, opt); offs.push(function () { t.removeEventListener(ev, fn, opt); }); }
    function rows() { return rowsWrap ? toArr(rowsWrap.querySelectorAll('.voices__row')) : []; }
    function trackOf(row) { return row.querySelector('.voices__track'); }

    /* --- GIF'i dondur: o anki kare canvas'a çizilir (CDN'in format dönüşümüne bağlı kalmadan) --- */
    function freeze() {
      if (still || !gif) return;
      if (!gif.complete || !gif.naturalWidth) {
        if (!stillWait) { stillWait = true; on(gif, 'load', function () { stillWait = false; update(); }); }
        return;
      }
      var node = null;
      try {
        node = document.createElement('canvas');
        node.width = gif.naturalWidth;
        node.height = gif.naturalHeight;
        node.getContext('2d').drawImage(gif, 0, 0, node.width, node.height);
      } catch (e) {
        node = null;
      }
      if (!node) {
        var src = gif.getAttribute('data-still');
        if (!src) return;
        node = document.createElement('img');
        node.alt = '';
        node.src = src;
      }
      node.className = 'voices__media voices__media--still';
      var host = gif.closest('picture') || gif;
      host.parentNode.insertBefore(node, host.nextSibling);
      still = node;
    }

    function media(paused) {
      if (video) {
        if (!reduce && !paused) {
          video.muted = true;
          if (video.preload !== 'auto') video.preload = 'auto';
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      }
      if (gif) {
        var hold = reduce || st.user;
        if (hold) freeze();
        if (still) still.hidden = !hold;
      }
    }

    function holding() { return st.focusHold || st.editHold || st.touchHold || st.modalHold; }

    function update() {
      var paused = st.user || !st.visible || document.hidden;
      root.classList.toggle('is-paused', paused);
      root.classList.toggle('is-user-paused', st.user);
      root.classList.toggle('is-holding', holding());
      media(paused);
    }

    /* --- sonsuz kayma --- */
    function ghostRow() {
      var rs = rows();
      if (wantRows < 2 || rs.length !== 1) return;
      var base = toArr(trackOf(rs[0]).children);
      if (base.length < 2) return;
      var row = document.createElement('div');
      row.className = 'voices__row voices__row--rev voices__row--ghost';
      row.setAttribute('aria-hidden', 'true');
      var ul = document.createElement('ul');
      ul.className = 'voices__track';
      var k = Math.ceil(base.length / 2);
      for (var i = 0; i < base.length; i++) ul.appendChild(cloneItem(base[(i + k) % base.length]));
      row.appendChild(ul);
      rowsWrap.appendChild(row);
    }

    function measure() {
      st.w = root.clientWidth;
      rows().forEach(function (row) {
        var track = trackOf(row);
        if (!track) return;
        var base = track.__base || (track.__base = toArr(track.children));
        if (!base.length) return;
        track.classList.remove('is-ready');
        track.style.animationDelay = '';
        var n = base.length;
        if (track.children.length === n) base.forEach(function (li) { track.appendChild(cloneItem(li)); });
        var shift = track.children[n].offsetLeft - base[0].offsetLeft;
        if (shift <= 0) return;
        var guard = 0;
        while (track.scrollWidth - shift < row.clientWidth + 4 && guard++ < 12) {
          base.forEach(function (li) { track.appendChild(cloneItem(li)); });
        }
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var unit = base[0].offsetWidth + gap || shift / n;
        track.style.setProperty('--voices-shift', shift + 'px');
        track.style.setProperty('--voices-dur', Math.max(8, speed * shift / unit).toFixed(2) + 's');
        void track.offsetWidth;
        track.classList.add('is-ready');
      });
    }

    /* Klavye / dokunma / editör tutuşu: kayan şerit, olduğu yerde kaydırılabilir satıra dönüşür; bırakınca kaldığı yerden devam eder. */
    function setHold(kind, v) {
      var was = holding();
      st[kind] = v;
      var now = holding();
      if (!st.moving || was === now) { update(); return; }
      var rs = rows();
      if (now) {
        var pos = rs.map(function (r) { var t = trackOf(r); return t ? -translateX(t) : 0; });
        update();
        rs.forEach(function (r, i) { var t = trackOf(r); if (t) r.scrollLeft = pos[i] + padLeft(t); });
        return;
      }
      rs.forEach(function (r) {
        var t = trackOf(r);
        if (!t) return;
        var shift = parseFloat(t.style.getPropertyValue('--voices-shift')) || 0;
        var dur = parseFloat(t.style.getPropertyValue('--voices-dur')) || 0;
        if (!shift || !dur) return;
        var off = r.scrollLeft - padLeft(t);
        var p = (((off % shift) + shift) % shift) / shift;
        if (r.classList.contains('voices__row--rev')) p = 1 - p;
        t.style.animationDelay = (-p * dur).toFixed(2) + 's';
      });
      update();
      rs.forEach(function (r) { r.scrollLeft = 0; });
    }

    /* --- kurulum --- */
    if (rowsWrap && !reduce) {
      ghostRow();
      root.classList.add('is-moving');
      if (!editor) root.classList.add('js-anim');
      st.moving = true;
      measure();
      if (toggle) toggle.hidden = false;
    }

    if (toggle) {
      on(toggle, 'click', function () {
        st.user = !st.user;
        if (toggleText) toggleText.textContent = st.user ? 'Oynat' : 'Durdur';
        update();
      });
    }

    /* --- görsel penceresi: bölümde tek <dialog>, içerik açılışta doldurulur --- */
    var modal = root.querySelector('[data-voices-modal]');
    if (modal) {
      var mImg = modal.querySelector('[data-voices-shot-img]');
      var slots = {
        stars: modal.querySelector('[data-voices-shot-stars]'),
        quote: modal.querySelector('[data-voices-shot-quote]'),
        name: modal.querySelector('[data-voices-shot-name]'),
        detail: modal.querySelector('[data-voices-shot-detail]'),
        who: modal.querySelector('.voicesm__who')
      };
      var opener = null, mDown = null;

      /* kart içindeki düğümün kopyası taşınır: <br> ve yıldızların aria-label'ı korunur */
      var put = function (slot, node) {
        if (!slot) return;
        slot.textContent = '';
        if (node) slot.appendChild(node.cloneNode(true));
        slot.hidden = !node;
      };
      var say = function (slot, node) {
        if (!slot) return;
        slot.textContent = node ? node.textContent : '';
        slot.hidden = !slot.textContent;
      };
      var veil = function (t) { return t === modal || !!(t.classList && t.classList.contains('voicesm__wrap')); };

      var fill = function (btn) {
        var item = btn.closest('.voices__item');
        mImg.removeAttribute('srcset');
        mImg.setAttribute('width', btn.getAttribute('data-w') || '1200');
        mImg.setAttribute('height', btn.getAttribute('data-h') || '1200');
        mImg.alt = btn.getAttribute('data-alt') || '';
        mImg.src = btn.getAttribute('data-full') || '';
        var set = btn.getAttribute('data-set');
        if (set) mImg.setAttribute('srcset', set);
        put(slots.stars, item && item.querySelector('.voices__stars'));
        put(slots.quote, item && item.querySelector('.voices__quote p:not(.voices__empty)'));
        say(slots.name, item && item.querySelector('.voices__name'));
        say(slots.detail, item && item.querySelector('.voices__detail'));
        /* adsız yorumda imza kutusu bütünüyle kalkar: boş kutu 12px'lik ara bırakmasın */
        if (slots.who) slots.who.hidden = !!((!slots.name || slots.name.hidden) && (!slots.detail || slots.detail.hidden));
      };

      /* kapanış: kilit kalkar, şerit kaldığı yerden devam eder, odak tıklanan görsele döner */
      var done = function () {
        document.documentElement.classList.remove('voices-lock');
        setHold('modalHold', false);
        mImg.removeAttribute('srcset');
        mImg.removeAttribute('src');
        var o = opener;
        opener = null;
        if (o && o.focus && o.isConnected) {
          try { o.focus({ preventScroll: true }); } catch (e) {}
        }
      };
      var shut = function () {
        if (!modal.open) { done(); return; }
        if (typeof modal.close === 'function') modal.close();
        else { modal.removeAttribute('open'); done(); }
      };

      on(modal, 'close', done);
      on(root, 'click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-voices-shot]') : null;
        if (!btn) return;
        fill(btn);
        opener = btn;
        if (typeof modal.showModal === 'function') {
          try { modal.showModal(); } catch (err) { return; }
        } else {
          modal.setAttribute('open', '');
        }
        document.documentElement.classList.add('voices-lock');
        setHold('modalHold', true);
      });
      var xBtn = modal.querySelector('[data-voices-shot-close]');
      if (xBtn) on(xBtn, 'click', shut);
      /* perdeye tıklama kapatır; basış da perdede başlamalı (panelden dışarı sürükleyip metin seçen kapanmasın) */
      on(modal, 'pointerdown', function (e) { mDown = e.target; });
      on(modal, 'click', function (e) {
        var d = mDown;
        mDown = null;
        if (veil(e.target) && veil(d || e.target)) shut();
      });
    }

    if (st.moving) {
      on(rowsWrap, 'focusin', function (e) {
        if (st.focusHold || !isKeyboard(e.target)) return;
        setHold('focusHold', true);
        var t = e.target;
        if (t && t.scrollIntoView && !t.classList.contains('voices__row')) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
      on(rowsWrap, 'keydown', function (e) {
        if (!st.focusHold && /^(Arrow(Left|Right)|Home|End)$/.test(e.key)) setHold('focusHold', true);
      });
      on(rowsWrap, 'focusout', function (e) {
        if (st.focusHold && (!e.relatedTarget || !rowsWrap.contains(e.relatedTarget))) setHold('focusHold', false);
      });
      /* Dokunma: şerit durur ve parmakla kaydırılabilir olur (momentum dahil);
         parmak kalktıktan ve kaydırma bittikten kısa süre sonra kaldığı yerden akmaya devam eder. */
      var touching = false;
      var release = function () {
        clearTimeout(timers.touch);
        if (touching || !st.touchHold) return;
        timers.touch = setTimeout(function () { setHold('touchHold', false); }, 2600);
      };
      rows().forEach(function (row) {
        on(row, 'touchstart', function () {
          touching = true;
          clearTimeout(timers.touch);
          if (!st.touchHold) setHold('touchHold', true);
        }, { passive: true });
        on(row, 'touchend', function () { touching = false; release(); }, { passive: true });
        on(row, 'touchcancel', function () { touching = false; release(); }, { passive: true });
        on(row, 'scroll', release, { passive: true });
      });
      on(window, 'resize', function () {
        clearTimeout(timers.resize);
        timers.resize = setTimeout(function () { if (root.clientWidth !== st.w) measure(); }, 180);
      });
    }

    on(document, 'visibilitychange', update);
    if (mq && mq.addEventListener) on(mq, 'change', function () { init(root); });

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          st.visible = en.isIntersecting;
          if (en.isIntersecting && (en.intersectionRatio >= 0.18 || en.intersectionRect.height >= 220)) root.classList.add('is-in');
        });
        update();
      }, { threshold: [0, 0.18, 0.4] });
      io.observe(root);
    } else {
      root.classList.add('is-in');
    }
    if (editor) root.classList.add('is-in');

    update();

    root.__voicesSelect = function (item) {
      setHold('editHold', true);
      var row = item.closest('.voices__row');
      if (row) row.scrollLeft = Math.max(0, item.offsetLeft - (row.clientWidth - item.offsetWidth) / 2);
    };
    root.__voicesDeselect = function () { setHold('editHold', false); };
    root.__voicesDestroy = function () {
      if (modal && modal.open) {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
      document.documentElement.classList.remove('voices-lock');
      offs.forEach(function (f) { f(); });
      offs = [];
      Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); });
      if (io) io.disconnect();
      if (video && !video.paused) video.pause();
      toArr(root.querySelectorAll('.voices__row--ghost, .is-clone, .voices__media--still')).forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      rows().forEach(function (r) {
        r.scrollLeft = 0;
        var t = trackOf(r);
        if (t) { t.__base = null; t.classList.remove('is-ready'); t.removeAttribute('style'); }
      });
      root.classList.remove('is-moving', 'js-anim', 'is-paused', 'is-user-paused', 'is-holding');
      if (toggle) toggle.hidden = true;
      if (toggleText) toggleText.textContent = 'Durdur';
      root.__voicesDestroy = root.__voicesSelect = root.__voicesDeselect = null;
    };
  }

  function initAll(scope) { toArr((scope || document).querySelectorAll('[data-voices]')).forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    toArr(e.target.querySelectorAll('[data-voices]')).forEach(function (r) { if (r.__voicesDestroy) r.__voicesDestroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('.voices__item') : null;
    var root = item && item.closest('[data-voices]');
    if (root && root.__voicesSelect) root.__voicesSelect(item);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('[data-voices]') : null;
    if (root && root.__voicesDeselect) root.__voicesDeselect();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
